function isApiResponse<T>(response: unknown): response is ApiResponse<T> {
	return (
		response != null
		&& typeof response === "object"
		&& "data" in response
		&& "success" in response
	);
}

export function parseApiResponse<T>(
	response: ApiResponse<T> | T | null | undefined,
): T | null {
	if (response == null) {
		return null;
	}

	if (isApiResponse<T>(response)) {
		return response.data ?? null;
	}

	return response as T;
}
